import { useState } from "react";
import { Plus } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/admin/AdminUI";
import { promptError } from "@/components/admin/PromptDialog";
import { api } from "@/lib/api";

export default function AddPromptForm({ onCreated }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const invalid = text.trim() ? promptError(text) : null;

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onCreated((await api("/admin/prompts", { body: { text: text.trim(), active: true } })).prompt);
      setText("");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Panel className="mb-6 p-5">
      <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row sm:items-start" data-testid="prompt-add-form">
        <div className="flex-1">
          <label htmlFor="new-prompt" className="sr-only">New prompt</label>
          <Input id="new-prompt" value={text} onChange={(e) => setText(e.target.value)} maxLength={80} placeholder="Add a prompt, like “My perfect weekend…”"
            className="h-11 rounded-xl" aria-invalid={!!invalid} data-testid="prompt-add-input" />
          {(invalid || error) && <p className="cw-error mt-2 text-xs" role="alert" data-testid="prompt-add-error">{error || invalid}</p>}
        </div>
        <Button type="submit" className="h-11 rounded-xl" disabled={busy || !text.trim() || !!invalid} data-testid="prompt-add-button"><Plus />{busy ? "Adding…" : "Add prompt"}</Button>
      </form>
    </Panel>
  );
}
